(() => {

  var AccordionApp = (() => {
    var toggle = (trigger) => {
      if (!trigger) return;
      const wrapper = document.querySelector(`[js-load-more-wrapper=${trigger.getAttribute('js-load-more-trigger')}]`);
      if (!wrapper) return;
      if (trigger.classList.contains('active')) {
        trigger.classList.remove('active');
        wrapper.classList.remove('active');
        wrapper.style.maxHeight = '0px';
      } else {
        trigger.classList.add('active');
        wrapper.classList.add('active');
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-load-more-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          toggle(element);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var TabApp = (() => {
    var open = (container, tab_id) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        element.classList.remove('active');
        if (String(element.getAttribute('js-tab-header')) === String(tab_id)) {
          element.classList.add('active');
        }
        if (String(element.getAttribute('js-tab-body')) === String(tab_id)) {
          element.classList.add('active');
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab]'), element.getAttribute('js-tab-header'));
        });
      });
    }
    return {
      init: initialize
    }
  })();
  let reviewAppBlockStyleBugFix = (() => {
    let initialize = () => {
      const reviewRatingStarEle = document.querySelectorAll(".jdgm-all-reviews-widget .jdgm-histogram__bar-content");
      const reviewRatingPercentageEle = document.querySelectorAll(".jdgm-all-reviews-widget .jdgm-histogram__percentage");
      const reviewRatingNumberEle = document.querySelectorAll(".jdgm-all-reviews-widget .jdgm-histogram__frequency");
      const totalReviewTextEle = document.querySelector(".jdgm-all-reviews-widget .jdgm-all-reviews__summary-text");
      
      let percentArr = [0, 0, 0, 0, 0];
      let restPercentage = 0;
      let totalReviewNum = 0;
      let reviewArr = [];

      reviewRatingNumberEle.forEach((ele) => {
        let numStr = ele.textContent;
        console.log("This is the number", numStr);
        if (numStr) {
          numStr = String(numStr);
          numStr = numStr.replace("(", "");
          numStr = numStr.replace(")", "");
          totalReviewNum += Number(numStr);
          reviewArr.push(Number(numStr));
        }
      });

      let subTotalPercent = 0;
      for (let i = 4; i >= 0; i --) {
        if (i != 0) {
          let percent = Math.round((reviewArr[i] / totalReviewNum) * 100);
          percentArr[i] = percent;
          subTotalPercent += percent;
        } else {
          percentArr[i] = 100 - subTotalPercent;
        }
      }

      function waitForElement(selector) {
        return new Promise(resolve => {
          const element = document.querySelector(selector);
          if (element) {
            return resolve(element);
          }

          const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
              resolve(el);
              observer.disconnect();
            }
          });

          observer.observe(document.body, {
            childList: true,   // ⚠️ correct property (not child_list)
            subtree: true
          });
        });
      }

      function applyReviewText(el, totalReviewNum) {
        el.innerHTML = `Basierend auf ${totalReviewNum} Bewertungen`;
      }
      // Usage
      waitForElement(".jdgm-all-reviews__summary-text")
        .then(el => {
          console.log("Found it!", el);
          applyReviewText(el, totalReviewNum);
          
           const observer = new MutationObserver(() => {
            // Disconnect to avoid infinite loop
            observer.disconnect();

            applyReviewText(el, totalReviewNum);

            // Re-observe after applying
            observer.observe(el, { childList: true, subtree: true, characterData: true });
          });

          observer.observe(el, { childList: true, subtree: true, characterData: true });

          for (let i = 0; i < 5; i ++) {
            reviewRatingStarEle[i].style.width = `${percentArr[i]}%`;
            reviewRatingPercentageEle[i].innerHTML = `${percentArr[i]}%`;
          }
        });

    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      AccordionApp.init();
      TabApp.init();
      reviewAppBlockStyleBugFix.init();
    }
    return {
      init: initialize
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();